module.exports = __webpack_public_path__ + "img/report.304c8cf2.svg";